import { TReservation } from '@/services/api/services-api';
import { addHours, isAfter, isBefore } from 'date-fns';

export const ReservationStatus = {
  Accepted: 'Accepted',
  Absent: 'Absent',
  Canceled: 'Canceled',
  Proposed: 'Proposed',
  Pending: 'Pending',
  Completed: 'Completed',
  Rejected: 'Rejected',
  Requested: 'Requested'
};

// states proposed by the admin
const PendingStates = new Set([
  ReservationStatus.Proposed,
  ReservationStatus.Rejected
]);

export const hasPendingActions = (reservations: TReservation[]) =>
  reservations.some((reservation) => PendingStates.has(reservation.status));

export type TReservationStatus = keyof typeof ReservationStatus;

export function getReservationsTexts(status: TReservationStatus, t: any) {
  switch (status) {
    case ReservationStatus.Requested:
      return t('common:status.requested');
    case ReservationStatus.Accepted:
      return t('common:status.accepted');
    case ReservationStatus.Rejected:
      return t('common:status.rejected');
    case ReservationStatus.Proposed:
      return t('common:status.proposed');
    case ReservationStatus.Completed:
      return t('common:status.completed');
    case ReservationStatus.Absent:
      return t('common:status.absent');
    case ReservationStatus.Canceled:
      return t('common:status.canceled');
    case ReservationStatus.Pending:
      return t('common:status.pending');
  }
}

export const PaymentStatus = {
  Pending: 'Pending',
  Rejected: 'Rejected',
  Approved: 'Approved'
};

export type TPaymentStatus = keyof typeof PaymentStatus;

export function getPaymentStatusTexts(status: TPaymentStatus, t: any) {
  switch (status) {
    case PaymentStatus.Rejected:
      return t('common:status.rejected');
    case PaymentStatus.Pending:
      return t('common:status.pending');
    case PaymentStatus.Approved:
      return t('common:status.approved');
  }
}

export const getHoursLeft = (reservations: TReservation[]) => {
  return reservations.filter(
    (reservation) =>
      reservation.status !== ReservationStatus.Completed &&
      reservation.status !== ReservationStatus.Absent &&
      reservation.status !== ReservationStatus.Canceled
  ).length;
};

export const isWithinNext24Hours = (dateToCheck: number | Date) => {
  const now = new Date();
  const twentyFourHoursLater = addHours(now, 24);

  return (
    isAfter(dateToCheck, now) && isBefore(dateToCheck, twentyFourHoursLater)
  );
};

export const calculateDepositAmount = (
  reservationPct: number,
  total: number
): number => {
  if (typeof reservationPct !== 'number' || typeof total !== 'number') {
    console.error('Error calculating. Function parameters should be numbers.');
    return 0; // Retorna 0 como valor por defecto en caso de errorr
  }

  return total * (reservationPct / 100);
};

export const groupReservationsByServiceDivisionGroupName = (
  reservations: TReservation[]
) => {
  console.log(reservations);
  const groupMap = reservations.reduce(
    (
      acc: Record<
        string,
        { id: string; name: string; reservations: TReservation[] }
      >,
      reservation
    ) => {
      const groupName =
        reservation.serviceDivisionGroup?.name ||
        reservation.serviceDivision.name;
      const groupId =
        reservation.serviceDivisionGroup?.id || reservation.serviceDivision.id;

      if (!acc[groupName]) {
        acc[groupName] = {
          id: groupId,
          name: groupName,
          reservations: []
        };
      }

      acc[groupName].reservations.push(reservation);
      return acc;
    },
    {}
  );

  // Convertir a array, ordenar reservas y calcular firstStartTime
  const groupedArray = Object.values(groupMap).map((group) => {
    group.reservations.sort((a, b) => a.startTime - b.startTime);
    return {
      ...group,
      firstStartTime: group.reservations[0].startTime
    };
  });

  // Ordenar el array de grupos por firstStartTime
  groupedArray.sort((a, b) => a.firstStartTime - b.firstStartTime);

  return groupedArray;
};
